import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  FormLayout,
  Select,
  Spinner,
  Box,
  Badge,
  Divider,
  Button,
  Collapsible,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import moment from "moment";
import JsonView from "@uiw/react-json-view";

const SortingCenterDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [optionsProfessors, setOptionsProfessors] = useState([]);
  const [selectedProfessor, setSelectedProfessor] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");

  const handleSelectChangeProfessor = (newValue) => {
    setSelectedProfessor(newValue);
  };
  const [activeModal, setActiveModal] = useState(false);
  const [activeModalReject, setActiveModalReject] = useState(false);
  const [activeModalApprove, setActiveModalApprove] = useState(false);
  const [ts, setTs] = useState("");

  const handleSubmit = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 2);
    form_data.append("professor_id", selectedProfessor);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModal(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleReject = () => {
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("status", 3);
    setIsSaving(true);
    axios
      .post(`/requests/${id}/edit-status`, form_data)
      .then((result) => {
        setIsSaving(false);
        setActiveModalReject(false);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const handleApprove = () => {};
  const handleChangeModal = () => {
    setActiveModal(false);
  };

  const handleChangeModalReject = () => {
    setActiveModalReject(false);
  };
  const handleChangeModalApprove = () => {
    setActiveModalApprove(false);
  };
  const [result, setResult] = useState("");

  useEffect(() => {
    fetchData();
  }, [ts]);

  async function fetchData() {
    let responseItem = "";

    try {
      responseItem = await axios.get(`/sorting-center/${id}`);
      setResult(responseItem.data.data);
    } catch (error) {
      console.log(error);
    }
  }
  const switchStatusColor = (param) => {
    switch (String(param)) {
      case "1":
        return "default";
      case "2":
        return "success";
      case "3":
        return "critical";
      default:
        return "";
    }
  };
  const [open, setOpen] = useState(false);
  const handleToggle = useCallback(() => setOpen((open) => !open), []);
  return result ? (
    <Page
      backAction={{
        onAction: () => navigate("/admin/sorting-center"),
      }}
      title={result?.ean ? result?.ean : ""}
      titleMetadata={<Badge>{result?.status}</Badge>}
      //   secondaryActions={[
      //     {
      //       content: `Set as ${result?.completed ? "uncompleted" : "completed"}`,
      //       loading: isSaving,
      //       // icon: CheckIcon,
      //       onAction: () => {
      //         setIsSaving(true);
      //         axios
      //           .patch(`/tournament-uprades/${id}/complete`, {
      //             completed: result?.completed ? 0 : 1,
      //           })
      //           .then((result) => {
      //             setIsSaving(false);
      //             //setActiveModal(false);
      //             setTs(+new Date());
      //           })
      //           .catch((err) => console.log(err));
      //       },
      //     },
      //   ]}
      // title={result?.first_name + " " + result?.last_name}
      // titleMetadata={
      //   result?.completed && <Badge tone="success">Completed</Badge>
      // }
      //   secondaryActions={[
      //     {
      //       content: "Approve",
      //       icon: CheckIcon,
      //       onAction: () => {
      //         setActiveModal(true);
      //       },
      //     },
      //     {
      //       content: "Reject",
      //       destructive: true,
      //       icon: XIcon,
      //       onAction: () => {
      //         setActiveModalReject(true);
      //       },
      //     },
      //   ]}
    >
      <Card>
        <Text as="h2" variant="headingSm">
          CLIENT INFO
        </Text>
        <Box paddingBlock="200">
          <FormLayout>
            <FormLayout.Group condensed>
              <Text>
                <b>ID</b>
                <br />
                {result?.client && result?.client?.id
                  ? result?.client?.id
                  : "-"}
              </Text>
              <Text>
                <b>First Name</b>
                <br />
                {result?.client && result?.client?.first_name
                  ? result?.client?.first_name
                  : "-"}
              </Text>
              <Text>
                <b>Last Name</b>
                <br />
                {result?.client && result?.client?.last_name
                  ? result?.client?.last_name
                  : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Phone Number</b>
                <br />
                {result?.client && result?.client?.phone_number
                  ? result?.client?.phone_number
                  : "-"}
              </Text>
              <Text>
                <b>Email</b>
                <br />
                {result?.client && result?.client?.email
                  ? result?.client?.email
                  : "-"}
              </Text>
              <Text>
                <b>Time</b>
                <br />
                {result?.updated_at
                  ? moment(result.updated_at).format("YYYY-MM-DD HH:mm:ss")
                  : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>City</b>
                <br />
                {result?.client && result?.client?.city
                  ? result?.client?.city
                  : "-"}
              </Text>
              <Text>
                <b>Country</b>
                <br />
                {result?.client && result?.client?.country
                  ? result?.client?.country
                  : "-"}
              </Text>
              <Text>
                <b>Full Address</b>
                <br />
                {result?.client && result?.client?.full_address
                  ? result?.client?.full_address
                  : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Longitude</b>
                <br />
                {result?.client && result?.client?.longitude
                  ? result?.client?.longitude
                  : "-"}
              </Text>
              <Text>
                <b>Latitude</b>
                <br />
                {result?.client && result?.client?.latitude
                  ? result?.client?.latitude
                  : "-"}
              </Text>
              <Text>
                <b>Zip Code</b>
                <br />
                {result?.client && result?.client?.zipCode
                  ? result?.client?.zipCode
                  : "-"}
              </Text>
            </FormLayout.Group>
          </FormLayout>
        </Box>

        <Text as="h2" variant="headingSm">
          ORDER DETAILS
        </Text>
        <Box paddingBlock="200">
          <FormLayout>
            <FormLayout.Group condensed>
              <Text>
                <b>ID</b>
                <br />
                {result?.order_number ? result?.order_number : "-"}
              </Text>
              <Text>
                <b>Status</b>
                <br />
                {result?.status ? result?.status : "-"}
              </Text>
              <Text>
                <b>Supplier</b>
                <br />
                {result?.supplier_name ? result?.supplier_name : "-"}
              </Text>
            </FormLayout.Group>

            <FormLayout.Group condensed>
              <Text>
                <b>Amount</b>
                <br />
                {result?.orderservices_description
                  ? result?.orderservices_description
                  : "-"}
              </Text>
              <Text>
                <b>Assigned Driver</b>
                <br />
                {result?.assigned_driver ? result?.assigned_driver : "-"}
              </Text>
              <Text>
                <b>Total Demand</b>
                <br />
                {result?.total_demand ? result?.total_demand : "-"}
              </Text>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <Text>
                <b>Number of boxes</b>
                <br />
                {result?.number_of_boxes !== null
                  ? result?.number_of_boxes
                  : "-"}
              </Text>
              <Text>
                <b>CBM</b>
                <br />
                {result?.cbm ? result?.cbm : "-"}
              </Text>
              <Text></Text>
            </FormLayout.Group>
            {/* <FormLayout.Group condensed>
              <Text>
                <b>Notes</b>
                <br />
                {result?.notes ? result?.notes : "-"}
              </Text>
            </FormLayout.Group> */}
          </FormLayout>
        </Box>
        <Text as="h2" variant="headingSm">
          NOTES
        </Text>
        <Box paddingBlock="200">
          <Text>{result?.notes ? result?.notes : "-"}</Text>
        </Box>
        <Button
          onClick={handleToggle}
          ariaExpanded={open}
          ariaControls="basic-collapsible"
        >
          {open ? "Hide Payload Json" : "Show Payload Json"}
        </Button>
        <Collapsible
          open={open}
          id="basic-collapsible"
          transition={{ duration: "300ms", timingFunction: "ease-in-out" }}
          expandOnPrint
        >
          <JsonView value={result?.payload} />
        </Collapsible>
      </Card>

      <Modal
        open={activeModal}
        onClose={handleChangeModal}
        title="Approve Request"
        primaryAction={{
          content: "Submit",
          onAction: handleSubmit,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "Cancel",
            loading: isSaving,
            onAction: handleChangeModal,
          },
        ]}
      >
        <Modal.Section>
          <Select
            label="Please assign a professor"
            options={optionsProfessors}
            onChange={handleSelectChangeProfessor}
            value={selectedProfessor}
            placeholder="Please select"
          />
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalReject}
        onClose={handleChangeModalReject}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleReject,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalReject,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>

      <Modal
        open={activeModalApprove}
        onClose={handleChangeModalApprove}
        title="Reject Request"
        primaryAction={{
          content: "Yes",
          onAction: handleApprove,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalApprove,
          },
        ]}
      >
        <Modal.Section>
          <Text>Are you sure you want to reject this request?</Text>
        </Modal.Section>
      </Modal>
    </Page>
  ) : (
    <div className="spinnerContainer">
      <div className="vertical-center">
        <Spinner size="large" />
      </div>
    </div>
  );
  function getFirstNonNullValue(obj) {
    for (const value of Object.values(obj)) {
      if (value !== null) {
        return value;
      }
    }
    return null;
  }
};

export default SortingCenterDetails;
